import React from "react";
import classNames from "classnames";
import { st } from "lib/index";

const getCompanyIdFromURL = () => {
  const splittedPathname = window.location.pathname.split("/");
  const indexOfC = splittedPathname.indexOf("c");
  const companyId = indexOfC >= 0 && splittedPathname[indexOfC + 1];
  return companyId;
};

export default function StockAvailability({
  slot,
  used = slot ? slot.total_stock_used : 0,
  left = slot ? slot.total_stock_left : 0,
  confirmed = slot && slot.confirmed,
  limit = slot ? slot.total_stock_limit : null,
  overbooked = limit !== null && used > limit,
  className,
  companyId = slot && slot.company_id.toString(),
  type = slot ? slot.stock_type : "person",
  ...rest
}) {
  const currentCompanyId = getCompanyIdFromURL();
  const isCurrentCompany = companyId === currentCompanyId;
  const isImportantAdmin = ["global_admin", "main_admin", "editor_admin"].includes(st.authorize.member.role);

  const showStock = () => {
    const stockLeftToShow = left > 10 || left === null ? ">10" : left;

    if (isCurrentCompany || isImportantAdmin) {
      return (
        <span className="text">
          {used}/{limit === null ? "∞" : limit}
        </span>
      );
    } else {
      return <span className="text">{stockLeftToShow}</span>;
    }
  };

  return (
    <span className={classNames("with-icon c-StockAvailability", className, { overbooked })} {...rest}>
      {confirmed && (
        <i style={{ color: "orange" }} className="icon material-icons">
          done
        </i>
      )}
      {showStock()}
      <i className="icon material-icons">{type === "person" ? "people" : "shopping_basket"}</i>
    </span>
  );
}

export function NoBookingStockAvailability({
  variant,
  used = variant ? variant.nb_total_stock_used : 0,
  limit = variant ? variant.nb_total_stock_limit : null,
  overbooked = limit !== null && used > limit,
  display,
}) {
  if (display) {
    return (
      <span>
        <span className="u-marginRight">{I18n.t("activerecord.attributes.coupon_code.total_stock_used")}</span>
        <span className={classNames("with-icon c-StockAvailability", { overbooked })}>
          <span className="text">
            {used}/{limit === null ? "∞" : limit}
          </span>
          <i className="icon material-icons">shopping_basket</i>
        </span>
      </span>
    );
  }

  return null;
}



// WEBPACK FOOTER //
// ./src/lib/components/StockAvailability.jsx